import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { UsersVM } from './users.viewmodel';

const UsersContext = React.createContext<UsersVM>(null);
const connectUsersVM = makeConnect(UsersContext);

export { UsersContext, connectUsersVM };
